import { Dropdown, Avatar } from "antd";
import { UserOutlined, DownOutlined } from "@ant-design/icons";

export default function LoginNavigation(props) {
  const { handleMenuClick, profileDropdown } = props;
    return (
        <Dropdown
          menu={{ items: profileDropdown, onClick: handleMenuClick }}
          placement="top"
          trigger={["click"]}
        >
          <div className="headerUser" style={{ cursor: "pointer" }}>
            <Avatar icon={<UserOutlined />} />
            <DownOutlined />
          </div>
        </Dropdown>
    );
}